import store from "store/store";

export const clearStore = () => {
  store.dispatch({ type: "LOGOUT"});
  window.location.href = "https://ehub-dc2.blockchaincloudapps.com/login";
}

